import "./art.css"
import DataVisualization from "../../components/data-visualization";
import { useEffect, useState } from "react";
import { LoadingScreen } from "@/features/loading-screen";
import { onExportData, getRole, type SortOption, type StatsType, type TagType, getAllData, getData, getFilterData, onDelete, onCreate, onUpdate, getStats } from "@/features/data/view-model/viewModel";
import { columns, columnsExport, filters, sortOptions, type ArtInsert, type ArtUpdate } from "@/features/data/pages/art/art-model";
import { useUser } from "@/hooks/useUser";
import { type ArtType } from "@/features/data/pages/art/art-model"

export const PAGE_SIZE = 15;


export function Art () {
  
  const {id: user_id} = useUser();

  const table = "art"
  const title = "Art";

  const [currentRole, setCurrentRole] = useState();     
  const [isLoading, setIsLoading] = useState(true)
  const [filterData, setFilterData] = useState({
    artist: [],
    assurance_location: [],
  });
  const [art, setArt] = useState([] as ArtType[]);
  const [count, setCount] = useState(0);
  const [stats, setStats] = useState({} as StatsType);
  const [exportData, setExportData] = useState([] as ArtType[]);
   

  const onExport = async (columns: string[], name?: string, sortOption?: SortOption, tags?: TagType[]) => { 
      onExportData(columnsExport, columns, "art", sortOption, tags, name);
  };

    const getArt = async (
        page: number,
        sortOption?: SortOption,
        tags?: TagType[]
      ) => {
        const { data, count } = await getData(page, table, sortOption, tags);
        setArt(data ?? []);
        setCount(count ?? 0);
      };

      const getAllArt = async () => {

          const { data } = await getAllData(table);
          setExportData(data);
    }
  

    const getFilterArt = async () => {
      const [artists, locations] = await Promise.all([
        getFilterData("art", "artist"),
        getFilterData("art", "assurance_location"),
      ]);
    
      setFilterData({
        artist: artists,
        assurance_location: locations,
      });
      };

    const getRoleArt = async () => {
      const { data } = await getRole();
      setCurrentRole(data);
    }

    const getStatsArt = async () => {
        const { data } = await getStats("art_dashboard");
        setStats(data)
    }

    const onDeleteArt = async (id: string) => {
      await onDelete(id, table);
    };

    const onCreateArt = async (values: ArtInsert) => {
      await onCreate(user_id, values, table)
    };

    const onUpdateArt = async (values: ArtUpdate, id: string) => {
      await onUpdate(user_id, values, table, id);
    };

    useEffect(() => {
      setIsLoading(true);
      getAllArt()
      getRoleArt()
      getStatsArt();
      getFilterArt();
      setIsLoading(false);
  }, [])

    return isLoading ? <LoadingScreen/> : 
    <>
        <DataVisualization<ArtType> 
            columns={columns} 
            columnsExport={columnsExport}
            count={count}
            data={art} 
            filters={filters}
            filterData={filterData}
            role={currentRole}
            title={title}
            table={table} 
            stats={stats}
            sortOptions={sortOptions}
            getData={getArt} 
            onCreate={onCreateArt}
            onExportData={onExport}
            onDelete={onDeleteArt} 
            onUpdate={onUpdateArt} 
        />         
    </>
};

export default Art;